<template>
  <v-layout v-if="getExaminationData && getExaminationData.examination" row wrap align-content-start fill-height class="pa-4">

    <!-- title - patien name with report status dropdown -->
    <v-flex xs12>
      <examination-info
        :examination="getExaminationData.examination"
        :patient="getPatient"
        :examinationTypeList="getExaminationTypeList"
        showStatusButton
        @reportStatusChange="setReportStatus($event)"
      >
        <template slot="right">
          <v-btn color="info" @click="goToHome()">
            Return Home
          </v-btn>
          <v-btn id="uploadScreenshotButtonA" style="background-color: #EA7500; color: #ffffff;" @click="uploadScreenshot()">
            上傳照片
          </v-btn>
          <v-btn id="uploadScreenshotButtonB" style="display: none;">
            Uploaded
          </v-btn>
          <v-btn style="background-color: #EA7500; color: #ffffff;" @click="goToPreview()">
            <v-icon>print</v-icon> &nbsp; 預覽列印
          </v-btn>
        </template>
      </examination-info>
    </v-flex>

    <v-flex xs12>
      <colon-report-bowel-cleanse-forms
        v-if="getExaminationData.examination.examination_typeID != EXAMINATION_TYPE_OF_GASTROSCOPY"
        :examination="getExaminationData"
        :sedatives="getSedativeList"
        @change="bowelCleanseFormChange"
      ></colon-report-bowel-cleanse-forms>
      <gastro-report-bowel-cleanse-forms
        v-if="getExaminationData.examination.examination_typeID == EXAMINATION_TYPE_OF_GASTROSCOPY"
        :examination="getExaminationData"
        :sedatives="getSedativeList"
        @change="bowelCleanseFormChange"
      ></gastro-report-bowel-cleanse-forms>
    </v-flex>

    <!-- bottom section - findings -->
    <!-- number of tabs depending on how many findings -->
    <!-- last two tabs are uncategorized and landmarks -->
    <v-flex xs12 class="mt-4">
      <ReportFindingDetails
       :reporType = reportType
      ></ReportFindingDetails>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ExaminationInfo from '@/components/ExaminationInfo.vue'
import GastroReportBowelCleanseForms from '@/components/GastroReportBowelCleanseForms.vue'
import ColonReportBowelCleanseForms from '@/components/ColonReportBowelCleanseForms.vue'
import ReportFindingDetails from './report types/ReportFindingDetails.vue'

export default {
  name: 'ReportDetail',

  components: {
    ExaminationInfo,
    GastroReportBowelCleanseForms,
    ColonReportBowelCleanseForms,
    ReportFindingDetails
  },

  updated() {
    if (Number(this.getExaminationData.examination.reportStatus) == 0) {
      this.setReportStatus('Editing');
    }
  },

  created() {
    window.onkeydown = function(e) {};
    window.onkeyup = function(e) {};

    this.$store.dispatch('examinations/fetchExaminationDetailAndOtherList', { examinationID: this.examinationID, accNo: this.accNo });
    this.$store.dispatch('examinations/resetStoreHiddenParameter');
    this.$store.dispatch('examinations/resetQuestionsList');
  },

  data() {
    return {
      // select dropdown items
      dropdownItems: {
        reportStatus: ['Unedited', 'Editing', 'Finalized'],
        reportStatusColors: {
          'Unedited': 'primary',
          'Editing': 'orange',
          'Finalized': 'green'
        }
      },
      EXAMINATION_TYPE_OF_GASTROSCOPY: 1
    }
  },


  computed: {
    ...mapGetters('examinations', [
      'getDoctorList',
      'getTechnicalStaffList',
      'getExaminationData',
      'getLandmarkList',
      'getExaminationTypeList',
      'getInspectionInstrumentList',
      'getWashInstrumentList',
      'getCleanMedList',
      'getSedativeList',
      'getPatient',
      'getStoreHiddenParameter'
    ]),

    examinationID () {
      if (Number(this.$route.params.examinationID) != 0) {
        return this.$route.params.examinationID;
      } else {
        if (this.getExaminationData != null) {
          return this.getExaminationData.examination.id;
        }
      }
    },

    accNo () {
      return (Number(this.$route.params.accNo) != 0) ? this.$route.params.accNo : 0;
    },

    reportType() {
      return this.getExaminationData.examination.examination_typeID
    },

    findingsData() {
      return this.getExaminationData.findings
    },

    getAllImages() {
      return this.getExaminationData.all
    }

  },

  methods: {
    ...mapActions('examinations', [
      'updateExaminationColumn',
      'addExaminationSedative',
      'deleteExaminationSedative'
    ]),

    uploadScreenshot() {
      if (document.getElementById('uploadScreenshotButtonA').innerHTML.split('Uploaded').length == 1) {
        this.$store.dispatch('examinations/notificationUniGateUploadScreenshot', { examinationID: this.examinationID }).then(() => {
          document.getElementById('uploadScreenshotButtonA').style = 'display: none;';
          document.getElementById('uploadScreenshotButtonB').style = 'background-color: green; color: #fff;';
          setTimeout(function() {
            document.getElementById('uploadScreenshotButtonA').style = 'background-color: #EA7500; color: #ffffff;';
            document.getElementById('uploadScreenshotButtonB').style = 'display: none;';
          }, 3000);
        });
      }
    },

    goToPreview() {
      this.$router.push({
        path: `/reports/${this.examinationID}/accNo/0/preview`
      })
    },

    goToHome() {
      this.$router.push({
        path: `/home`
      })
    },

    setReportStatus(item) {
      const value = this.dropdownItems.reportStatus.indexOf(item)
      this.setExaminationColumn('reportStatus', value)
    },

    bowelCleanseFormChange(obj) {
      var value = obj.event
      const timeFiled = ["insertionTime", "proximalColonWithTime", "withdrawTime", "totalExamTime"]
      const reg = "([0-1][0-9]|2[0-3])\:[0-5][0-9]\:[0-5][0-9]"
      const regExp = new RegExp(reg)

      if (obj.field == "antiplateletStopDays") {
        value = parseInt(obj.event, 10)
      } else if (timeFiled.includes(obj.field) && !regExp.test(value)) {
        value = "00:00:00"
      }

      this.setExaminationColumn(obj.field, value)
    },

    setExaminationColumn(column, value) {
      let d = {
        id: this.examinationID,
        column: column,
        value: value
      }
      this.updateExaminationColumn(d)
    },

    handleSedative(action, event) {
      const examinationSedativeID = event ? event.id : null
      this[`${action}ExaminationSedative`]({
        examinationID: this.examinationID,
        examinationSedativeID
      })
    }

  }
}
</script>

<style lang="scss">
  @import '@/styles/pages/page_reportDetail.scss';
</style>